import Joi from 'joi';
import JoiDate from '@hapi/joi-date';

export const schema = Joi.object({
  rut: Joi.string().min(3).error(new Error('Debe ingresar RUT')),
  purchaseDate: Joi.extend(JoiDate)
    .date()
    .format('YYYY-MM-DD')
    .error(new Error('Formato de fecha inválido')),
  clientName: Joi.string()
    .min(3)
    .error(new Error('Debe ingresar su nombre completo.')),
  phone: Joi.string()
    .min(9)
    .max(9)
    .pattern(new RegExp(/^\d+$/))
    .error(new Error('El teléfono debe contener 9 dígitos.')),
  email: Joi.string()
    .pattern(
      new RegExp(/^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i),
    )
    .error(new Error('Formato de correo inválido.')),
  expectedDate: Joi.extend(JoiDate)
    .date()
    .format('YYYY-MM-DD')
    .error(new Error('Formato de fecha inválido')),
  comment: Joi.string()
    .min(5)
    .max(200)
    .error(new Error('Máximo 200 caracteres.')),
});
